import React, { createContext, useContext, useState } from "react";

const ModeContext = createContext(null);

// "investor" = approved content only; "internal" = drafts + warnings visible.
export function ModeProvider({ children }) {
  const [mode, setMode] = useState("investor");
  const isInternal = mode === "internal";
  return (
    <ModeContext.Provider value={{ mode, setMode, isInternal }}>
      {children}
    </ModeContext.Provider>
  );
}

export const useMode = () => useContext(ModeContext);
